/*
 * @Author: wangjing showangjing@didiglobal.com
 * @Date: 2022-07-18 19:45:14
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @LastEditTime: 2023-03-23 11:16:23
 * @FilePath: /fe-eshotel/src/common/source_channel.js
 * @Description: 容器来源
 */

import { mpx } from '@didi/es-mpx-creator'
import storage from '@didi/es-mpx-storage'
import {
  TankerRecognizer,
  TankerRules,
  browserEnv,
  DD_MINI_DEFAULT_CODE,
  DD_ES_DEFAULT_CODE,
  WEB_PC_PASSPORT_CODE,
  SERVICE_ORDER_CODE
} from '@didi/es-tanker-recognizer'

// 容器来源
export const source_channel = () => {
  if (__mpx_mode__ === 'dd') {
    // 星河小程序
    return DD_MINI_DEFAULT_CODE
  } else {
    mpx.use(storage)
    if (__mpx_mode__ === 'web' && isPCEntry()) {
      // pc浏览器
      return WEB_PC_PASSPORT_CODE
    } else {
      const options = {
        userAgent: window.navigator.userAgent.toLowerCase()
      }
      const recognizer = new TankerRecognizer(options)
      recognizer.ruleAdapte(TankerRules)
      const matched = recognizer.match()
      return matched.code
    }
  }
}

// 是否在企业APP内打开H5
export const isH5FromESApp = () => {
  return source_channel() == DD_ES_DEFAULT_CODE
}

// 是否在pc浏览器打开
export const isPCEntry = () => {
  return !browserEnv().isMobile
}

